import { Button, Classes, Dialog, H3, H6 } from '@blueprintjs/core';
import * as React from 'react';
import { deleteCheckIn } from '../../../adminFunctions/deleteCheckIn';

interface ActiveCheckInVoidButtonProps {
  checkInId: string;
  currentUser?: any;
}

interface ActiveCheckInVoidButtonState {
  isOpen: boolean;
  voiding: boolean;
}

class ActiveCheckInVoidButton extends React.PureComponent<
  ActiveCheckInVoidButtonProps,
  ActiveCheckInVoidButtonState
> {
  public state: ActiveCheckInVoidButtonState = {
    isOpen: false,
    voiding: false,
  };

  public render() {
    const { isOpen, voiding } = this.state;
    const dialogProps: Dialog['props'] = {
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      isOpen,
      onClose: this.toggleModal,
    };

    return (
      <>
        <Dialog {...dialogProps}>
          <div className={Classes.DIALOG_BODY}>
            <H6>Are you sure you want to void this check-in?</H6>
            <H3>This action cannot be undone!</H3>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button disabled={voiding} onClick={this.toggleModal}>
                cancel
              </Button>
              <Button
                intent="danger"
                loading={voiding}
                onClick={this.voidCheckIn}>
                void
              </Button>
            </div>
          </div>
        </Dialog>
        <Button intent="danger" onClick={this.toggleModal}>
          Void Check-In
        </Button>
      </>
    );
  }

  private toggleModal = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  private voidCheckIn = async () => {
    const { checkInId, currentUser } = this.props;

    this.setState({ voiding: true });

    await deleteCheckIn(checkInId, currentUser.userId);

    this.setState({ isOpen: false, voiding: false });
  };
}

export default ActiveCheckInVoidButton;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/VoidButton.tsx